import { Tag, Tooltip } from 'antd';
import { formatDateTime } from '@/utils/datetime';

// ==============================|| BATCH PROCESS DETAILS - SHARED HELPERS ||============================== //

export const fmt = (v) => formatDateTime(v);

export const yesNo = (v) =>
  v === true ? (
    <Tag color="green">Yes</Tag>
  ) : v === false ? (
    <Tag color="red">No</Tag>
  ) : (
    <Tag>—</Tag>
  );

export const statusTagColor = (status = '') => {
  const v = String(status).toLowerCase();
  if (v.includes('complet') || v.includes('approved') || v.includes('pass')) return 'green';
  if (v.includes('reject') || v.includes('fail') || v.includes('hold')) return 'red';
  if (v.includes('progress') || v.includes('review') || v.includes('running')) return 'blue';
  if (v.includes('pending')) return 'gold';
  if (v.includes('pause')) return 'orange';
  return 'default';
};

export const priorityTagColor = (priority = '') => {
  const v = String(priority).toLowerCase();
  if (v === 'high' || v === 'critical') return 'red';
  if (v === 'medium') return 'orange';
  if (v === 'low') return 'blue';
  return 'default';
};

export const personName = (person) =>
  person ? `${person.name || '—'}${person.designation ? ` (${person.designation})` : ''}` : '—';

export const formatSeconds = (seconds) => {
  if (seconds === null || seconds === undefined) return '—';
  const s = Number(seconds);
  if (Number.isNaN(s)) return '—';
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return m > 0 ? `${m}m ${rem}s` : `${rem}s`;
};

export const TicketTag = ({ ticket }) => {
  if (!ticket) return '—';
  return (
    <Tooltip
      title={
        <div>
          <div>{ticket.desc || 'No description'}</div>
          <div style={{ marginTop: 4, opacity: 0.85 }}>
            Raised by {personName(ticket.created_by)} on {fmt(ticket.created_at)}
          </div>
        </div>
      }
    >
      <div className="flex flex-col gap-1" style={{ cursor: 'help' }}>
        <span style={{ fontSize: 12 }}>
          <Tag color={priorityTagColor(ticket.priority)}>{ticket.priority || '—'}</Tag>
          <b>{ticket.unique_id || ticket.id}</b>
        </span>
        <span style={{ fontSize: 12 }}>{ticket.title}</span>
        <span style={{ fontSize: 11, color: '#64748b' }}>
          {ticket.current_stage}
          {ticket.is_completed ? ' · Completed' : ' · Open'}
        </span>
      </div>
    </Tooltip>
  );
};
